import { post } from "../utils/request";
import wx from "wx";

var wxConfig = (options, success, error) => {
    var winUrl = window.location.href;
    post({
        url: "/gateway/manageBedrock/wechatcs/getAccessToken",
        data: {
            // appid: "wx279ecb3fef5cc08d"
            appKey: "wx_gzh",
        },
    }).then(
        (res) => {
            if (res.result === "success") {
                post({
                    url: "/gateway/manageBedrock/wechatcs/getSignatureByToken",
                    data: {
                        accessToken: res.data.sessionKey,
                        url: winUrl.split("#")[0],
                    },
                }).then(
                    (data) => {
                        if (data.result === "success") {
                            console.log(data.data);
                            wx.config(
                                Object.assign(options, {
                                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                                    appId: "wx279ecb3fef5cc08d", // 必填，公众号的唯一标识
                                    timestamp: data.data.timestamp, // 必填，生成签名的时间戳
                                    nonceStr: data.data.noncestr, // 必填，生成签名的随机串
                                    signature: data.data.signature, // 必填，签名
                                })
                            );
                            success(data);
                        } else {
                            console.log(data);
                        }
                    },
                    (data) => {
                        console.log(data);
                        if (error) {
                            error(data);
                        }
                    }
                );
            } else {
                console.log(res);
            }
        },
        (res) => {
            console.log(res);
        }
    );
};

export { wxConfig };



// WEBPACK FOOTER //
// ./src/utils/wxConfig.js